export const EDGES = ["top", "left", "bottom", "right"];
export const CORNERS = ["topLeft", "topRight", "bottomLeft", "bottomRight"];
export const MINIMUM_HEIGHT = 32;
export const MINIMUM_WIDTH = 98;
export const OPPOSITE_EDGE_MAP = {
	left: "right",
	right: "left",
	top: "bottom",
	bottom: "top",
	topLeft: "bottomRight",
	topRight: "bottomLeft",
	bottomLeft: "topRight",
	bottomRight: "topLeft",
};
export const SPLIT_HANDLE_MAP = {
	bottomLeft: ["bottom", "left"],
	bottomRight: ["bottom", "right"],
	leftBottom: ["left", "bottom"],
	rightBottom: ["right", "bottom"],
	topRight: ["top", "right"],
	topLeft: ["top", "left"],
	rightTop: ["right", "top"],
	leftTop: ["left", "top"],
	left: ["left"],
	right: ["right"],
	top: ["top"],
	bottom: ["bottom"],
};
